import Image from 'next/image'
import CheckIcon from '../RoofersLanding/CheckIcon'
import HomepageBookCallButton from '../HomePageV2/HomepageBookCallButton'

const BULLET_POINTS = [
    'Target by geography, property profile, lot size, home value, and seasonal demand windows',
    'Build campaigns around lawn care plans, design and install, seasonal cleanups, reactivations, and neighborhood farming',
    'Fast in-house production: mail drops in days, not weeks',
    'Track response with call tracking, QR codes, and campaign-level reporting',
]

function HeroVisual() {
    return (
        <div className="relative flex min-h-[300px] items-center justify-center sm:min-h-[420px] lg:min-h-[520px]">
            <div className="relative w-full max-w-[300px] min-[380px]:max-w-[340px] sm:max-w-[460px] lg:max-w-[490px]">
                <Image
                    src="/assets/homepage/landscaping-hero.png"
                    alt="Landscaping direct mail campaign examples with response notifications"
                    width={1124}
                    height={992}
                    priority
                    className="h-auto w-full object-contain"
                />
            </div>
        </div>
    )
}

export default function LandscapingHero({ onBookCall }) {
    return (
        <section className="relative overflow-hidden border-b border-black/10 bg-[linear-gradient(170deg,#FFF9F2_0%,#FFFCF7_70%)]">
            <div className="pointer-events-none absolute right-[-180px] top-[-240px] h-[600px] w-[600px] rounded-full bg-[radial-gradient(circle,rgba(250,179,49,0.18)_0%,transparent_65%)]" />
            <div className="pointer-events-none absolute bottom-[-160px] left-[-120px] h-[440px] w-[440px] rounded-full bg-[radial-gradient(circle,rgba(237,92,47,0.10)_0%,transparent_65%)]" />
            <div className="container mx-auto grid gap-12 px-5 py-[44px] md:px-0 lg:grid-cols-2 lg:gap-14 lg:py-[76px] xl:pb-[40px]">
                <div className="homepage-v2-hero-stagger flex flex-col">
                    <div className="mb-6 inline-flex w-fit items-center gap-2 rounded-full border border-[rgba(237,92,47,0.2)] bg-white px-4 py-[7px] text-xs font-bold uppercase tracking-[0.04em] text-[#ED5C2F] shadow-[0_2px_8px_-2px_rgba(237,92,47,0.15)]">
                        <span className="homepage-v2-pulse-dot h-1.5 w-1.5 rounded-full bg-[#ED5C2F]" />
                        <span className="text-xs font-semibold text-secondary uppercase tracking-wider">
                            For Residential Landscapers
                        </span>
                    </div>

                    <h1 className="mb-[22px] text-[48px] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#3F454F]">
                        <span className="block">More landscaping jobs.</span>
                        <span className="block olm-gradient-text">
                            Less wasted mail.
                        </span>
                    </h1>

                    <p className="mb-6 max-w-[600px] text-[18px] font-normal leading-[1.65] text-[#4A5160]">
                        We help you reach the homeowners most likely to need
                        lawn care, landscape installs, hardscaping, irrigation,
                        or seasonal cleanups, with direct mail that is targeted,
                        timed, and built to get noticed.
                    </p>

                    <div className="flex flex-wrap items-center gap-3">
                        <HomepageBookCallButton
                            onClick={onBookCall}
                            className="w-fit">
                            Plan your landscaping campaign
                        </HomepageBookCallButton>
                    </div>

                    <div className="mt-4 max-w-[500px]">
                        <p className="text-[13px] leading-[1.65] text-[#4A5160]">
                            Best fit for landscaping companies doing roughly
                            <strong className="font-semibold text-[#3F454F]">
                                {' '}
                                $1M-$5M in annual revenue
                            </strong>{' '}
                            that are actively investing in growth and want a
                            more repeatable direct mail program.
                        </p>
                    </div>

                    <div className="mt-6 flex max-w-[740px] flex-col gap-2">
                        {BULLET_POINTS.map((point, i) => (
                            <div
                                key={i}
                                className="flex flex-row items-start gap-3">
                                <div className="mt-0 flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-green-100">
                                    <CheckIcon className="w-3 h-3 text-green-700" />
                                </div>
                                <span className="text-[14px] leading-5 text-[#4A5160]">
                                    {point}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="homepage-v2-fade-up">
                    <HeroVisual />
                </div>
            </div>
        </section>
    )
}
